import { useTranslations } from "use-intl";
import { useTransition } from "react";
import { Trash2 } from "lucide-react";
import { useNavigate } from "react-router";
import { deleteSession } from "@/lib/actions";
import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
  AlertDialogTrigger,
} from "@/components/ui/alert-dialog";
import { Button } from "@/components/ui/button";

export function DeleteSessionButton({ sessionId }: { sessionId: string }) {
  const t = useTranslations("progress");
  const tc = useTranslations("common");
  const [pending, start] = useTransition();
  const navigate = useNavigate();
  return (
    <AlertDialog>
      <AlertDialogTrigger asChild>
        <Button variant="destructive" className="mt-8 w-full">
          <Trash2 /> {t("deleteSession")}
        </Button>
      </AlertDialogTrigger>
      <AlertDialogContent>
        <AlertDialogHeader>
          <AlertDialogTitle>{tc("deleteConfirmTitle")}</AlertDialogTitle>
          <AlertDialogDescription>{tc("deleteConfirmText")}</AlertDialogDescription>
        </AlertDialogHeader>
        <AlertDialogFooter>
          <AlertDialogCancel>{tc("cancel")}</AlertDialogCancel>
          <AlertDialogAction variant="destructive" disabled={pending} onClick={() =>
              start(async () => {
                await deleteSession(sessionId);
                navigate("/progress", { replace: true });
              })
            }>
            {tc("delete")}
          </AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
}
